import { render } from "./CustomerDropdown.vue?vue&type=template&id=74ad21cf"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app2.hof.services/releases/217/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__